module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/briefing_de-9cfcd41de3fffb3ebe3c07a006e36e42.png";